import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import DataTablesContain from '../../Component/Tables/DataTable3';
import { useTranslation } from 'react-i18next';

const DataTable3 = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Dashboard")} title={t("Proxy List")} />
      <DataTablesContain />
    </Fragment>
  );
};
export default DataTable3;
